// image wraped with link -> added data-facnybox attribute to envoke fancybox (exept gallery items)
// example:

//<a href="images/content/sample-02.jpg">
// <img src="" data-src="https://placehold.co/300x368" alt="">
//</a>

// Converts to:

//<a href="images/content/sample-02.jpg" data-fancybox>
// <img src="" data-src="https://placehold.co/300x368" alt="">
//</a>

export {}

const links = document.querySelectorAll(".entry-content .kt-img-link, .entry-content a")

links.forEach((link) => {
  const image = link.querySelector(
    ':scope[href$=".jpg"] > img, :scope[href$=".png"] > img, :scope[href$=".jpeg"] > img, :scope[href$=".webp"] > img, :scope[href$=".avif"] > img',
  )

  if (!image) return

  !link.hasAttribute("data-fancybox") && link.setAttribute("data-fancybox", "")

  const alignsClasses = ["aligncenter", "alignright", "alignleft"]

  alignsClasses.forEach((align) => {
    if (!image.classList.contains(align)) return

    image.classList.remove(align)
    link.classList.add(align)
  })
})
